// JsFromRoutes CacheKey 8d572658cfd66aca3d70e41aff04be72
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/prospects'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/prospects/:id'),
}
